module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-up-b93d35c4aae154d391e4fbc287871902.svg";